import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  MASS_RETAG_ROUTE_NAME,
  PLAYERS_MASSTAG_PERMISSIONS,
  TRANSLATION_GROUP_MASS_RETAG,
} from '@modules/mass-retag/constants';
import { getTranslationKeys } from '@modules/mass-retag/translations';
import {
  ADMIN_PLAYERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

export class MassRetagModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: MASS_RETAG_ROUTE_NAME,
      path: 'mass_retag',
      component: () => import('./pages/MassRetagPage/MassRetagPage.vue'),
      permission: PLAYERS_MASSTAG_PERMISSIONS.PLAYERS_RETAG,
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PLAYERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PLAYERS_MASS_RETAG'),
      to: {
        name: MASS_RETAG_ROUTE_NAME,
      },
      permission: PLAYERS_MASSTAG_PERMISSIONS.PLAYERS_RETAG,
      id: MASS_RETAG_ROUTE_NAME,
      order: 30,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_MASS_RETAG, getTranslationKeys);
  }
}
